import { get } from 'lodash'

export default function () {
  if (get(this.$route, 'params.id', null) !== null) {
    this.getMeeting(get(this.$route, 'params.id', null))
  }
  this.searchMeeting()
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/details/resources/mounted.js